<template>
    <div>
        <!--loader - message--->
        <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
        <div class="middleBox whitebox border radius mb-5">
            <div class="congratulations">
                <div class="logo_congrats">
                    <img src="../../../../static/fxView/images/check.svg" alt="Congratulations" />
                </div>
                <div class="subtitle">
                    <h3>
                        Congratulations 
                        <span class="green">
                            {{ get_user.profile.firstname }}
                            {{ get_user.profile.lastname }}
                        </span>
                    </h3>
                    <p>Your demo account has been successfully created. Your credentials are:</p>
                </div>
            </div>
            <div class="full-width ButtonTrade submitButton align-items-center justify-content-center d-flex mt-3 w-100">
                <a class="prism_btn btn_sm" href="#" target="_blank">Submit</a>
            </div>
        </div>
    </div>
</template>
<script>
import { fxViewMixins } from "@/plugins/fxView";
export default {
    name: 'PAYMENTCALLBACK',
    mixins: [fxViewMixins],
    data() {
        return {
            pageLoader: false,
        };
    },
    methods: {
    },
}
</script>


// WEBPACK FOOTER //
// src/components/fxView/deposit/paymentCallback.vue